<script>
  import { fade } from 'svelte/transition';
  import UserStore from '../stores/user';
  import fetchData from '../api.js';
  import {link, push} from 'svelte-spa-router'
  import { locale, _ } from 'svelte-i18n';
  import { onMount } from 'svelte';
  import { allowed_stores , storeNames , apply_store_list } from '../variables';
  import Note from '../components/Note.svelte';
  import Popup from '../components/Popup.svelte';
  import Header from '../components/Header.svelte'; 
  import Preloader from '../components/Preloader.svelte';
  let isLoading = true;

  export let params = {};

  let popupActive = false;
  let popupAlertActive = false;

  let stores = localStorage.getItem('stores');
  stores = JSON.parse(stores);

  let store = storeNames[params.store_id]

  let notes = [];

  let notes_types = {
      'in' : [],
      'out' : [],
      'closed' : []
  }

  let scannedNotes = {
    in : {},
    out : {}
  }

  $: outCounter = Object.keys(scannedNotes.out).length;
  $: inCounter = Object.keys(scannedNotes.in).length;

  let notesType = '';

  onMount(async() => {


    if (!$UserStore || !$UserStore.data){
      push('/login');
      return;
    }

    //notes = JSON.parse(localStorage.getItem('notes')) || [];
    //let lastFetchedDate = localStorage.getItem('lastFetchedDate');
    let lastFetchedDate = null;

    const currentDate = new Date();
    const to = currentDate.toISOString().split('T')[0];
    currentDate.setDate(currentDate.getDate() - 21);
    const from = lastFetchedDate || new Date(currentDate.getTime() - (21 * 24 * 60 * 60 * 1000)).toISOString().split('T')[0];

    const formData = {
        store : [""],  
        from : from,
        to: to,        
        action : 'get_orders_by_store',
        token : $UserStore.data
    }

    let data = await fetchData(formData);

    isLoading = false;

    notes = data.data;

    // notes = notes
    // .concat(data.data)
    // .filter((note, index, array) => {
    //     // Find the index of the first occurrence of the note with the same DeliveryNoteNo
    //     let firstIndex = array.findIndex(item => item.DeliveryNoteNo === note.DeliveryNoteNo);
    //     // Return only the notes with unique DeliveryNoteNo or the one from data.data
    //     return firstIndex === index || firstIndex >= notes.length;
    // });    

    // localStorage.setItem('notes', JSON.stringify(notes));
    // localStorage.setItem('lastFetchedDate', from);

    //console.log('no tes',notes)

    notes.map((data)=>{

      if (data.Status==3) {

        //list.closed.push(note);

      } else if ( data.SourceCard != params.store_id ) {

        notes_types.in.push(data);

      } else {

        notes_types.out.push(data);

      }

    })

    //console.log(notes_types)


    const parseDate = (dateString) => new Date(
      dateString.substring(0, 4), // Year
      dateString.substring(4, 6) - 1, // Month (0-based, so subtract 1)
      dateString.substring(6, 8) // Day
    );

    // Define a comparator function for sorting by date in descending order
    const sortByDateDesc = (a, b) => parseDate(b.CreateDate) - parseDate(a.CreateDate);

    // Sort the 'list.in' and 'list.out' arrays by date in descending order
    notes_types.in.sort(sortByDateDesc);
    notes_types.out.sort(sortByDateDesc);
    notes_types.closed.sort(sortByDateDesc); 
    
    notesType = 'in';

    document.addEventListener('keydown', handleKeyDown);
    
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };

  });

  function processBarcode(scannedBarcode) {

    if (scannedBarcode.includes('PACK-')) {
      // Remove the "PACK-" prefix
      let barcodeWithoutPrefix = scannedBarcode.replace('PACK-', '');

      // Split the string into parts
      let parts = barcodeWithoutPrefix.split('-');

      // Remove leading zeros from the first part
      let firstPart = parts[0].replace(/^0+/, '');

      firstPart = firstPart.padStart(3, '0');

      let lastPart = parts[1].replace(/^0+/, '');

      lastPart = lastPart.padStart(6, '0');

      // Combine the processed parts into the final result
      let result = firstPart + lastPart;

      return result;
    } else {
      return scannedBarcode;
    }
  }

  //console.log('PACK-0071-714715',processBarcode('PACK-0071-714715'));



  let scannedBarcode = '';

  function handleKeyDown(event) {
    // Check if the key pressed is a number or Enter
    //if (/^\d$/.test(event.key)) {
    if (/^[\dA-Za-z-]$/.test(event.key)) {
      scannedBarcode += event.key;
    } else if (event.key === 'Enter') {

      console.log('scannedBarcode',scannedBarcode)

      scannedBarcode = processBarcode(scannedBarcode)

      console.log('scannedBarcode',scannedBarcode)

      const note = document.getElementById('note' + scannedBarcode);

      if (!note) {
        // Handle the case when the note does not exist
        popupAlertActive = true;
        scannedBarcode = '';
        return;
      }

      const dataIndex = note.getAttribute('data-index');
      const dataNote= note.getAttribute('data-note');
      const dataDestination = note.getAttribute('data-destination');
      const dataStore = note.getAttribute('data-store');
      const dataStatus = note.getAttribute('data-status');

      scannedNotes[notesType][dataNote] = {
        barcode : scannedBarcode,
        destination : dataDestination,
        note : dataNote,
        store : dataStore,
        status : dataStatus,
      }

      const selectedNote = notes_types[notesType].splice(dataIndex, 1)[0];      
      selectedNote.scanned = true;
      notes_types[notesType].unshift(selectedNote);

      console.log(notes_types[notesType])

      notes_types = { ...notes_types};

      
      // if (scannedNotes > 0) {
      //   document.querySelector('.noteItemsApproval').classList.remove('hidden');
      // } else {
      //   document.querySelector('.noteItemsApproval').classList.add('hidden');
      // }
      

      scannedBarcode = '';
    }
  }

  const removeSelectedNote = (e) => {



    delete scannedNotes[notesType][e.detail.note];

    notes_types[notesType][e.detail.index].scanned = false      

    notes_types = { ...notes_types};

    scannedNotes = { ...scannedNotes};
    
  }

  const ClosePopup = (e) => {

    popupActive = false;
    popupAlertActive = false;

  }

  const ApprovePopup= async(e) => {

    let formData = {
        notes : [],    
        action : 'update_delivery_note',
        token : $UserStore.data,
        name : $UserStore.name
    }

    //console.log(scannedNotes[notesType],notesType);

    for(let key in scannedNotes[notesType]) {

      let note = scannedNotes[notesType][key]
      let store = parseInt(note.store);
      let destination = parseInt(note.destination);
      let original_status = note.status;
      let status = 3;

      if (apply_store_list.includes(store)) {
          console.log('Apply logic for store:', store);
          if (apply_store_list.includes(destination)) {
              console.log('Apply logic for destination:', destination);
              status = 6;

              if (original_status==6) {
                  status = 3;
              }
          }

      }

      if ([69,70,79,390,65].includes(store)) {
          store = 1;
      }
      

      formData.notes.push({
          store : store,
          note : note.note,
          status :status,
          destination : destination,
      })

    }    

    let data = await fetchData(formData);
    if (data.success==1) {

      popupActive = false

      notes_types[notesType] = notes_types[notesType].filter((noteData) => {
        const matchingNote = formData.notes.find((noteLooper) => {

          // console.log(noteData,noteLooper)
          return noteData.DeliveryNoteNo == noteLooper.note;
        });

        //console.log(matchingNote)

        if (matchingNote) {
          if (matchingNote.status == 3) {
            return false;
          } else {
            noteData.scanned = false;
            noteData.Status = matchingNote.status;
          }
        }

        return true;
      });

      notes_types[notesType] = [...notes_types[notesType]];
      notes_types = {...notes_types};

      scannedNotes[notesType] = {};
      //console.log(scannedNotes[notesType],notesType)
      scannedNotes = {...scannedNotes}




      formData = {
          merchant_id : $UserStore.id,
          action : 'set_log',
          notes : formData.notes,
          name : $UserStore.name,
          url : 'https://yehuda.dreamax.co.il/api/rest/set_log'
      }

      data = await fetchData(formData);



    }
    
   
  }


</script>

<style>
.grid{
  display: flex;
}
.grid > div{
  flex: 1;
  text-align: right;
  padding: 8px 20px;
  border: 1px solid #575757;
  background-color: #000000;
  color: #fff;
  /* border-radius: 54px; */
  margin: 0px;
  position: relative;
  opacity: 0.6;
}
.grid > div.selected {
  opacity: 1;
}
.grid > div .counter {
  position: absolute;
  background-color: #FFCF01;
  border-radius: 50px;
  text-align: center;
  width: 24px;
  height: 25px;
  color: #000;
  font-weight: bold;
  top: 6px;
  left: 5px;
  line-height: 25px;
}
.grid > div .counter.empty {
  background-color: #575757;
} 
.scanned {
  background-color: aqua;;
}
.approve_button {
  margin-top: 15px;
  padding: 15px 20px;
  background-color: #FFCF01;
  color: black;
  border: none;
  border-radius: 40px;
  cursor: pointer;
  width: 150px;
  font-weight: bold;
  font-size: 16px;
  margin:auto;
  text-decoration: none;
  position: fixed;  
  bottom:20px;
  left: 0;
  right: 0;
}
.page-title {
  background: #000;
  color: #fff;
  padding: 10px
}
.title {
    font-size: 20px;;
    font-weight: bold;
}
.content {
  font-size: 15px;
  margin: 15px 0 5px;
  font-weight: bold;
}
</style>
<Preloader isLoading={isLoading} />
<Header />
<Popup popupActive={popupAlertActive} on:ClosePopup={ClosePopup}>
  <div slot="title" class="title">{$_('note.alert_title')}</div>
  <div slot="content" class="content">{$_('store.alert_note_not_exist')}</div>
</Popup>
<Popup {popupActive} approveActive="true" on:ClosePopup={ClosePopup} on:ApprovePopup={ApprovePopup}>
  <div slot="title" class="title">{$_('store.approve_title')}</div>
  <div slot="content" class="content">{$_('store.approve_content')}</div>
</Popup>
<div class="page" transition:fade={{ delay: 250, duration: 300 }}>
  <div class="page-title title">{store}</div>  
  <div class="grid">
    <div class="" class:selected={notesType=='in'} on:click={()=>{ notesType = 'in'; }}>
      <span>{$_('store.in')}</span>
      <span class="counter" class:empty={ inCounter==0 }>{inCounter}</span>
    </div>
    <div class="" class:selected={notesType=='out'} on:click={()=>{ notesType = 'out'; }}>
      <span>{$_('store.out')}</span>
      <span class="counter" class:empty={ outCounter==0 }>{outCounter}</span>
    </div>
  </div>
  <div class="notes">   
    {#if notesType == 'in'}
        {#each notes_types.in as note,index(note)}
            <Note {note} {params} {index} on:removeSelectedNote={removeSelectedNote}></Note>   
        {/each}
    {:else if notesType == 'out'}
        {#each notes_types.out as note,index(note)}
          <Note {note} {params} {index} on:removeSelectedNote={removeSelectedNote}></Note>        
        {/each}
    {/if}
  </div>
  {#if Object.keys(scannedNotes.in).length>0 || Object.keys(scannedNotes.out).length>0}
  <div class="approve_button" on:click={ ()=> { popupActive = true; } }>{$_('store.approve')}</div>
  {/if}
</div>
